import EntityProxy from '@/models/EntityProxy'

export default class User extends EntityProxy {

  static deepClass() {
    return EntityProxy
  }

  constructor(attributes, options) {
    super(attributes, options)

    if (this.accountUser && typeof this.accountUser === 'object') {
      this.role = this.accountUser.role
      this.cnpjs = this.accountUser.cnpjs
    }
  }
}